import dispatcher from '../../dispatchers/dispatcher';

export function dispatcherActions(data, type){
    dispatcher.dispatch({
        data: data,
        type: type
    })
}





// WEBPACK FOOTER //
// ./src/applications/actions/actions.js